import { render, staticRenderFns } from "./SearchFilterTokens.vue?vue&type=template&id=be8a1562&scoped=true&"
import script from "./SearchFilterTokens.vue?vue&type=script&lang=js&"
export * from "./SearchFilterTokens.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be8a1562",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('be8a1562')) {
      api.createRecord('be8a1562', component.options)
    } else {
      api.reload('be8a1562', component.options)
    }
    module.hot.accept("./SearchFilterTokens.vue?vue&type=template&id=be8a1562&scoped=true&", function () {
      api.rerender('be8a1562', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2nsu5DKq6GjdN/JS/comp/SearchFilterTokens.vue"
export default component.exports